import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { formattedDate } from "../../Date";
import { ToastContainer, toast } from "react-toastify";
import Select, { components } from "react-select";
import { AddwithWhiteCircle, DropdownArrow, CrosswithRedCircle, AddwithBlueCircle } from "../../AllSvg";
import { CSSForSelect, CSSForSelect20vWWidth, CSSForSelectModern, handleErrorToast, ProgressModal } from "../../CustomFunctions";
import { Check, Landmark, Loader, MapPin, Save, Sparkles, Users, Wallet, X } from "lucide-react";

const ExpenseAdd = ({ imprestDetails, getExpansee, imprest, getimprest }) => {
  const company = sessionStorage.getItem("sitemanagement_project_sub_company")
  const [show, setShow] = useState(false);
  const projectId = sessionStorage.getItem("sitemanagement_project")

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => {
    setImprestExist(null)
    setErrors({});
    setInputState({});
    setShow(false)
  };
  const handleShow = () => {
    setFormData({
      name: "",
      imprest: "",
      date: formattedDate,
      emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
      project: projectId ? projectId : "null",

      stationary_item: 0,
      electronic_item: 0,
      imprestbank_details: "",
      account_holder_name: "",
      account_number: "",
      bank_name: "",
      multiple_emp_account_detail: [],

      ifsc_code: "",
      pan_card: "",
      phone_number: "",
      grocery: 0,
      other_name: "",
      other: 0,
      other_details: [
        {
          other_name: "",
          amount: 0,
          approved_other: 0,
          remaining_other: 0
        }
      ],
      no_of_days: "",
      remarks: "",
      imprest_name: "",
      imprest_open: false,

    })
    getFilterProjects()
    setShow(true)
  };



  const [formData, setFormData] = useState({
    name: "",
    imprest: "",
    date: formattedDate,
    emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
    project: projectId ? projectId : "null",

    stationary_item: 0,
    electronic_item: 0,
    grocery: 0,
    imprestbank_details: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    pan_card: "",
    phone_number: "",
    bank_name: "",
    multiple_emp_account_detail: [],

    other_name: "",
    other: 0,
    other_details: [],
    no_of_days: "",
    remarks: "",
    imprest_name: "",
    imprest_open: false,

  });

  const [imprestExist, setImprestExist] = useState(null);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      imprestExist ? "imprest" : "imprest_name",
      imprestExist ? null : "no_of_days",
    ].filter(Boolean);
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    if (!imprestExist) {
      if (!formData.other_details || formData.other_details.length === 0) {
        newErrors.other_details = "At least one Other Detail entry is required!";
      } else {
        formData.other_details.forEach((detail, index) => {
          if (!detail.other_name || detail.other_name.trim() === "") {
            newErrors[`other_details_${index}_other_name`] = `Other Name at row ${index + 1} is required!`;
          }
        });
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleProjectInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "project_id") {
      const selectedProject = projectList.find((project) => project.id === value);

      if (selectedProject) {
        const fullProjectName = `${selectedProject.site_prcode}-${selectedProject.project_short_name}`;
        let projectName = fullProjectName;
        if (fullProjectName.length > 200) {
          const maxShortNameLength = 200 - selectedProject.site_prcode.length - 4;
          const truncatedShortName = selectedProject.project_short_name.slice(0, Math.max(maxShortNameLength, 0));
          projectName = `${selectedProject.site_prcode}-${truncatedShortName}...`;
        }

        setFormData({
          ...formData,
          project_id: value,
          imprest_name: projectName,
        });

        setInputState({
          ...inputState,
          project_id: "green",
          imprest_name: "green",
        });
      } else {
        setFormData({
          ...formData,
          project_id: value,
          imprest_name: "",
        });

        setInputState({
          ...inputState,
          project_id: value.trim() ? "green" : "",
          imprest_name: "",
        });
      }
    } else {
      setInputState({
        ...inputState,
        [name]: value.trim() ? "green" : "",
      });

      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  //******************Valedation End*********************** */
  const handleOtherInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers[index] = {
        ...newOthers[index],
        [name]: value
      };
      return {
        ...prevFormData,
        other_details: newOthers
      };
    });
  };

  const handleRemoveOthers = (index) => {
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers.splice(index, 1);
      return {
        ...prevFormData,
        other_details: newOthers
      };
    });
  };

  const handleAddOthers = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      other_details: [
        ...prevFormData.other_details,
        {
          other_name: "",
          amount: 0,
          approved_other: 0,
          remaining_other: 0
        },
      ]
    }));
  };

  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      person: formData?.multipleperson?.length,
      imprest_open: true,
      other_details: expenseTypeFormat,
      amount_change_reason: 'Confirmed',
    };

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true); //loading logic
      setUploadProgress(0);
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {
        const url = imprestExist
          ? `${BASE_URL}/siteproject/expense/`
          : `${BASE_URL}/siteproject/createImprestAndExpense/`;

        const data = imprestExist ? formData : updatedFormData;
        let res = await axios.post(url, data);

        if (res.status === 200 || res.status === 201) {
          if (imprestExist) {
            try {
              let imp = await axios.put(`${BASE_URL}/siteproject/imprest/${formData.imprest}/`, {
                imprest_open: false
              });
              if (imp.status === 200) {
                await getExpansee();
                await getimprest();
                clearInterval(interval);
                toast.dismiss(loadingToastId);
                toast.success("Expense Added Successfully");
                setFormData({
                  name: "",
                  imprest: "",
                  date: formattedDate,
                  imprestbank_details: "",
                  account_holder_name: "",
                  account_number: "",
                  ifsc_code: "",
                  pan_card: "",
                  phone_number: "",
                  multiple_emp_account_detail: [],
                  bank_name: "",

                  emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
                });
                setShow(false);
              } else {
                toast.error("Error closing imprest: " + imp.statusText);
              }
            } catch (error) {
              toast.error("Error closing imprest: " + error.message);
            }
          } else {
            await getExpansee();
            await getimprest();
            clearInterval(interval);
            toast.dismiss(loadingToastId);
            toast.success("Expense & Imprest Added Successfully");
            setFormData({
              name: "",
              imprest: "",
              imprestbank_details: "",
              account_holder_name: "",
              account_number: "",
              ifsc_code: "",
              pan_card: "",
              phone_number: "",
              multiple_emp_account_detail: [],
              bank_name: "",

              date: formattedDate,
              emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
            });
            handleClose();
          }
        }

      } catch (err) {
        //toast Logic
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err, loadingToastId)
      } finally {
        clearInterval(interval);
        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };




  const [projectList, setProjectList] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const getFilterProjects = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
          `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/null/`
          : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
            `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/null/`
            : `${BASE_URL}/siteproject/project/`
      );
      setProjectList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };
  const [employeeList, setEmployeeList] = useState([]);

  const getEmployeebySite = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/${formData.project}/`);
      setEmployeeList(response.data);
    } catch (error) {
      console.error(error);

    }
  };


  useEffect(() => {
    if (show === true && formData.project !== "null") {
      getEmployeebySite();
    }
  }, [show, formData.project])


  const projectOptions = imprestDetails
    .sort((a, b) => a.siteproject_prcode - b.siteproject_prcode)
    .map(project => ({
      value: project.site_project,
      label: `${project.siteproject_prcode} - ${project.siteproject_name}`,
    }));



  const [employeeIds, setemployeeIds] = useState([]);


  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.id,
      label: `${emp.emp_code} - ${emp.name}`,
    }));

  const handleEmployeeOptions = (options) => {
    if (!options || options.length === 0) {
      setemployeeIds([]);
    } else {
      const ids = options.map(opt => opt.value);
      setemployeeIds(ids);
    }
  };


  const Option = (props) => (
    <components.Option {...props}>

      <label title="Star" class="star">
        <input id="star-checkbox" checked={props.isSelected}
          onChange={() => null} className="checkbox" type="checkbox" />
        <div className="svg-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-outline"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-filled"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="100"
            width="100"
            className="svg-celebrate"
          >
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
          </svg>
        </div>
      </label>
      {props.label}
    </components.Option>
  );



  const MenuList = (props) => {
    const { options, selectProps } = props;

    const filteredOptions = options.filter(
      (opt) => opt.label.toLowerCase() !== "other"
    );

    const selectedValues = selectProps.value?.map((i) => i.value) || [];
    const filteredValues = filteredOptions.map((i) => i.value);

    const isAllSelected = filteredValues.every((val) =>
      selectedValues.includes(val)
    );

    const handleToggle = () => {
      if (isAllSelected) {
        const preserveOther = selectProps.value?.filter(
          (i) => i.label.toLowerCase() === "other"
        ) || [];
        selectProps.onChange(preserveOther);
      } else {
        const preserveOther = selectProps.value?.filter(
          (i) => i.label.toLowerCase() === "other"
        ) || [];
        selectProps.onChange([...filteredOptions, ...preserveOther]);
      }
    };

    return (
      <components.MenuList {...props}>
        <button
          type="button"
          onClick={handleToggle}
          style={{
            width: "100%",
            padding: "6px 0",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: "1px solid #e3e3e3",
            background: "white"
          }}
        >
          {isAllSelected ? "Unselect All" : "Select All"}
        </button>

        {props.children}
      </components.MenuList>
    );
  };

  useEffect(() => {
    setemployeeIds([]);
  }, [formData.project]);


  useEffect(() => {
    if (employeeIds.length !== 0) {
      setFormData((prev) => ({
        ...prev,
        multiple_emp_account_detail: employeeIds
      }))
    }
  }, [employeeIds]);

  const role = sessionStorage.getItem("sitemanagement_role")

  const [imprestDetailss, setImprestDetailsss] = useState([]);

  useEffect(() => {

    const filterData = imprestDetails.filter(i => i.site_project === formData.project)
    setImprestDetailsss(filterData);
    setFormData((prev) => ({
      ...prev,
      imprestbank_details: filterData[0]?.id || "",
      account_holder_name: filterData[0]?.account_holder_name || "",
      account_number: filterData[0]?.account_number || "",
      ifsc_code: filterData[0]?.ifsc_code || "",
      pan_card: filterData[0]?.pan_card || "",
      phone_number: filterData[0]?.phone_number || "",
      bank_name: filterData[0]?.bank_name || "",
    }))

  }, [imprestDetails, formData.project])


  const [expenseTypeFormat, setexpenseTypeFormat] = useState([]);
  const getexpenseTypeFormat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/siteproject/impresttypebysubcompany/${company}/`);

      const formattedFormatData = res.data.map(item => ({
        other_name: item.other_name || "",
        amount: item.amount || 0,
        approved_other: item.approved_other || 0,
      }));

      setFormData({
        ...formData,
        other_details: formattedFormatData,
      });

      setexpenseTypeFormat(formattedFormatData);
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  }

  useEffect(() => {
    if (show) {
      getexpenseTypeFormat()
    }
  }, [show])

  return (
    <>
      <button title="Add Expense" className="btn-animated" onClick={handleShow}>
        <AddwithWhiteCircle /> Expense
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <Wallet size={24} />
              </div>
              <div>
                <Modal.Title>Add Expense</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Log an expense against an existing imprest, or create a new one</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <div className="form-section">
              <div className="section-title">
                <Wallet size={18} />
                <h4>Expense Details</h4>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label> Expense Name<span className="required">*</span></label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Expense Name"
                    onChange={handleInputChange}
                    value={formData.name}
                    className={errors.name ? "error" : inputState.name ? "success" : ""}
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>
              </div>

              <div className="requirement-mode-grid" style={{ marginTop: '10px' }}>
                <div
                  className={`requirement-mode-card ${imprestExist === true ? 'selected' : ''}`}
                  onClick={() => setImprestExist(true)}
                >
                  <div className="requirement-mode-icon strict">
                    <Landmark size={20} />
                  </div>
                  <h5>Existing Imprest</h5>
                  <p>Log this expense against an imprest that's already open.</p>
                  <div className="requirement-mode-check">
                    {imprestExist === true && <Check size={14} />}
                  </div>
                </div>

                <div
                  className={`requirement-mode-card ${imprestExist === false ? 'selected' : ''}`}
                  onClick={() => setImprestExist(false)}
                >
                  <div className="requirement-mode-icon basic">
                    <Sparkles size={20} />
                  </div>
                  <h5>No Imprest</h5>
                  <p>Create a new imprest along with this expense.</p>
                  <div className="requirement-mode-check">
                    {imprestExist === false && <Check size={14} />}
                  </div>
                </div>
              </div>
            </div>

            {imprestExist === null ? null : imprestExist !== false ? (
              <div className="form-section">
                <div className="section-title">
                  <Landmark size={18} />
                  <h4>Against Imprest</h4>
                </div>
                <div className="form-grid">
                  <div className="form-field">
                    <label> Select Imprest<span className="required">*</span></label>
                    <select
                      name="imprest"
                      onChange={handleInputChange}
                      value={formData.imprest}
                      className={errors.imprest ? "error" : inputState.imprest ? "success" : ""}
                    >
                      <option value="">Select imprest</option>
                      {imprest
                        .filter((imp) => imp.imprest_open === true)
                        .map((e, index) => (<option key={index} value={e.id}>{e.imprest_name}</option>))
                      }
                    </select>
                    {errors.imprest && <span className="error-message">{errors.imprest}</span>}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="form-section">
                  <div className="section-title">
                    <MapPin size={18} />
                    <h4>New Imprest Details</h4>
                  </div>

                  <div className="form-grid">
                    {!projectId && (
                      <div className="form-field">
                        <label><MapPin size={14} /> For Project<span className="required">*</span></label>
                        <Select
                          name="project"
                          options={projectOptions}
                          value={projectOptions?.find(opt => opt.value === formData.project) || null}
                          onChange={(selected) => {
                            setFormData({
                              ...formData,
                              project: selected ? selected.value : "null",
                            });
                          }}
                          placeholder="Select Project"
                          isSearchable
                          isClearable
                          styles={CSSForSelectModern}
                        />
                        {errors.project && <span className="error-message">{errors.project}</span>}
                      </div>
                    )}

                    <div className="form-field">
                      <label> Date<span className="required">*</span></label>
                      <input
                        type="date"
                        name="date"
                        onChange={handleInputChange}
                        value={formData.date}
                        className={errors.date ? "error" : inputState.date ? "success" : ""}
                      />
                      {errors.date && <span className="error-message">{errors.date}</span>}
                    </div>

                    <div className="form-field">
                      <label> Imprest Name<span className="required">*</span></label>
                      <input
                        type="text"
                        name="imprest_name"
                        placeholder="Imprest Name"
                        onChange={handleInputChange}
                        value={formData.imprest_name}
                        className={errors.imprest_name ? "error" : inputState.imprest_name ? "success" : ""}
                      />
                      {errors.imprest_name && <span className="error-message">{errors.imprest_name}</span>}
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="section-title">
                    <Wallet size={18} />
                    <h4>Expense Breakdown</h4>
                  </div>

                  <div className="form-grid">
                    {formData.other_details.map((other, index) => (
                      <div className="form-field" key={index}>
                        <label style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
                          <span>Expense Name</span>
                          {index !== 0 && (
                            <button type="button" title="Remove" className="ub-file-remove" style={{ padding: '2px' }} onClick={() => handleRemoveOthers(index)}>
                              <X size={14} />
                            </button>
                          )}
                        </label>
                        <input
                          type="text"
                          name="other_name"
                          placeholder="Other Expense Name"
                          onChange={(e) => handleOtherInputChange(index, e)}
                          value={other.other_name}
                        />
                      </div>
                    ))}
                  </div>

                  <button type="button" title="Add Expense" className="btn-secondaryy" style={{ marginTop: '10px' }} onClick={handleAddOthers}>
                    <AddwithBlueCircle />
                    Add Another Expense
                  </button>
                </div>

                <div className="form-section">
                  <div className="section-title">
                    <Users size={18} />
                    <h4>Persons Involved</h4>
                  </div>

                  <div className="form-field full-width">
                    <label> Name Of Person<span className="required">{formData.project === "null" ? " (Select Project First)*" : "*"}</span></label>
                    <Select
                      options={employeeOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}

                      placeholder="Select Name"
                      onChange={handleEmployeeOptions}
                      value={employeeOptions.filter((opt) => employeeIds?.includes(opt.value))}
                      styles={CSSForSelectModern}
                    />
                    {errors.employeeIds && <span className="error-message">{errors.employeeIds}</span>}
                  </div>

                  <div className="form-grid">
                    <div className="form-field">
                      <label><Users size={14} /> Number of Persons<span className="required" style={{ fontSize: '10px' }}>(Read-Only)</span></label>
                      <input
                        type="number"
                        placeholder="0"
                        readOnly
                        value={employeeIds.length}
                      />
                    </div>

                    <div className="form-field">
                      <label> Number of Days</label>
                      <input
                        type="number"
                        min={0}
                        placeholder="Days"
                        name="no_of_days"
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange}
                        value={formData.no_of_days}
                        className={errors.no_of_days ? "error" : inputState.no_of_days ? "success" : ""}
                      />
                      {errors.no_of_days && <span className="error-message">{errors.no_of_days}</span>}
                    </div>

                    <div className="form-field full-width">
                      <label> Remarks</label>
                      <textarea
                        name="remarks"
                        placeholder="Your feedback"
                        onChange={handleInputChange}
                        value={formData.remarks}
                        rows={2}
                        className={errors.remarks ? "error" : inputState.remarks ? "success" : ""}
                      />
                      {errors.remarks && <span className="error-message">{errors.remarks}</span>}
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="form-actions">
              <button type="button" className="btn-secondaryy" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                <span>{loading ? 'Adding...' : 'Add'}</span>
              </button>
            </div>

            <ToastContainer
              position="top-center"
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export { ExpenseAdd };